import { styled } from '../../../../../theme';
import { JourneyTitleStylesProps } from '.';

export const TitleStyled = styled.div`
display: block;
margin: auto;
line-height: 1.2;
text-align: ${(props: JourneyTitleStylesProps) => (props.center ? 'center' : 'left')};
width: 70%;
flex-grow: 1;

${(props: JourneyTitleStylesProps) =>
	props.white &&
	`
	color: #fff;
`}

@media(max-width:320px) {
	width: ${(props: JourneyTitleStylesProps) => (props.width ? props.width : '100')}%;
}

${(props: JourneyTitleStylesProps) =>
	props.fullWidth &&
	`
	width: 100%;
`}

${(props: JourneyTitleStylesProps) =>
	props.color &&
	`
	color: ${props.color};
`}

${(props: JourneyTitleStylesProps) =>
	props.marginTop &&
	`
	margin-top: ${props.marginTop}pt;
`}

${(props: JourneyTitleStylesProps) =>
	props.marginBottom &&
	`
	margin-bottom: ${props.marginBottom}pt;
`}

${(props: JourneyTitleStylesProps) =>
	props.width &&
	`
	width: ${props.width}%;
	${props.fullWidth && 'margin-left: 0;'}
`}

b {
	font-weight: 400;
}
`;
